"use client";
import { useEffect, useRef } from "react";

/**
 * Aynı periyodu paylaşan tüm aboneler için TEK setInterval.
 *
 * Ana sayfada 84 kart × 2 RotatingText = 168 ayrı 2 saniyelik zamanlayıcı vardı;
 * ekrandaki ~20 kart için saniyede 20 ayrı setState turu demek. Ortak tick ile
 * tüm rotasyonlar aynı karede olur ve React hepsini tek batch'te işler.
 *
 * Zamanlayıcı, o periyodun ilk abonesiyle kurulur, son abone çıkınca kapanır.
 */
type Tick = () => void;

const groups = new Map<number, { timer: ReturnType<typeof setInterval>; subs: Set<Tick> }>();

const subscribeTick = (intervalMs: number, tick: Tick) => {
  let group = groups.get(intervalMs);
  if (!group) {
    const subs = new Set<Tick>();
    group = {
      subs,
      timer: setInterval(() => {
        subs.forEach((fn) => fn());
      }, intervalMs),
    };
    groups.set(intervalMs, group);
  }
  group.subs.add(tick);

  return () => {
    const current = groups.get(intervalMs);
    if (!current) return;
    current.subs.delete(tick);
    if (current.subs.size === 0) {
      clearInterval(current.timer);
      groups.delete(intervalMs);
    }
  };
};

/**
 * @param callback  Her tick'te çağrılır. Kimliği değişse bile ABONELİK YENİLENMEZ —
 *                  ref üzerinden okunur, aksi hâlde her index değişiminde
 *                  zamanlayıcı sıfırlanırdı.
 * @param intervalMs Periyot; aynı değeri kullanan tüm aboneler aynı tick'i paylaşır.
 * @param enabled   false iken abonelik hiç kurulmaz.
 */
export const useSharedInterval = (
  callback: () => void,
  intervalMs: number,
  enabled: boolean,
) => {
  const callbackRef = useRef(callback);

  // Render gövdesinde ref yazmak yasak (react-hooks/refs) — effect'te güncelleniyor.
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) return;
    return subscribeTick(intervalMs, () => callbackRef.current());
  }, [enabled, intervalMs]);
};

export default useSharedInterval;
